import { stockStateLabel } from '../../utils/inventoryLabels';
import { STOCK_GROUP_BY } from './stockConstants';

/**
 * The rows on screen as a sheet, with the headers a person reads.
 *
 * Numbers go out as numbers so the sheet can add them up; the listing shows
 * them formatted, and a formatted number is text to a spreadsheet.
 *
 * @param {Array<object>} rows - As `inventories/stock/` sent them.
 * @param {'sku'|'sku_lot'|null} groupedBy - `null` is the detail by location.
 * @returns {Array<object>}
 */
export const buildStockExportRows = (rows, groupedBy) =>
  rows.map((row) =>
    groupedBy
      ? {
          Cliente: row.company_name,
          SKU: row.product_sku,
          Producto: row.product_name,
          ...(groupedBy === STOCK_GROUP_BY.SKU_LOT ? { Lote: row.lot || '' } : {}),
          Disponible: Number(row.available),
          Reservado: Number(row.reserved ?? 0),
          Total: Number(row.total),
          Unidad: row.base_uom,
        }
      : {
          Cliente: row.company_name,
          SKU: row.product_sku,
          Producto: row.product_name,
          Bodega: row.warehouse_name,
          Ubicación: row.slot_name || 'Sin ubicar',
          Lote: row.lot || '',
          Estado: stockStateLabel(row.state),
          Cantidad: Number(row.quantity),
          Unidad: row.base_uom,
        }
  );

/**
 * @param {object|null} warehouse - The warehouse in use, or `null` for all.
 * @param {'sku'|'sku_lot'|null} groupedBy
 * @returns {string}
 */
export const stockExportFileName = (warehouse, groupedBy) =>
  `inventario-${warehouse ? warehouse.name : 'todas'}-${groupedBy ? 'consolidado' : 'detalle'}.xlsx`;
